import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { dropdownBoundQuickAddOpenAtom, RydeUiUnit } from "@ryde/shared";

import { appendSuffixToEntity } from "./use-dynamic-forms.helpers";

interface IUseDropdownQuickAdd {
  entity?: RydeUiUnit;
  name: string;
}

export const useDropdownQuickAdd = ({ entity, name }: IUseDropdownQuickAdd) => {
  const suffixToEntity = appendSuffixToEntity({
    entity: entity || "unknown",
    suffix: name,
  });

  const [isQuickAddOpen, setIsQuickAddOpen] = useRecoilState(
    dropdownBoundQuickAddOpenAtom(suffixToEntity),
  );

  const closeQuickAdd = useEvent((): void => {
    setIsQuickAddOpen(false);
  });

  const openQuickAdd = useEvent((): void => {
    setIsQuickAddOpen(true);
  });

  return {
    isQuickAddOpen,
    suffixToEntity,
    openQuickAdd,
    closeQuickAdd,
  };
};
